import React from "react";
import orderBy from "lodash/orderBy";
import ParticipantSubRole from "shared/enums/ParticipantSubRole";
import { useGetNonAttendeeUnapprovedHistory } from "./dataloader";
import { NominationHistoryProps, NominationHistoryService } from "./types";
import DateTimeHelper from "shared/utils/dateTimeHelper";

export default function useNominationHistory(props: NominationHistoryProps): NominationHistoryService {
  const { data = [] } = useGetNonAttendeeUnapprovedHistory({
    applicantId: props.applicantId,
    participantSubRole: ParticipantSubRole.ORGANIZATION_ADMIN
  });

  const nominationHistory = React.useMemo(() => {
    return orderBy(data, item => DateTimeHelper.parseDate(item.initiationDate), ["desc"]);
  }, [data]);

  return {
    nominationHistory
  };
}
